"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconContactByPhone = function IconContactByPhone(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M15.258 5.375a10.36 10.36 0 0 1 8.842 8.802l.037.286-.994.114a9.36 9.36 0 0 0-7.746-8.17l-.275-.042zm6.355 9.12a7.86 7.86 0 0 0-6.694-6.64l-.138.99.25.04a6.86 6.86 0 0 1 5.622 5.981l.994-.112zm-7.034-4.14a5.34 5.34 0 0 1 4.536 4.445l.032.233-.994.114a4.34 4.34 0 0 0-3.504-3.768l-.208-.034zm-6.366 3.53a3.38 3.38 0 0 1 4.844-.142l2.884 2.884c1.272 1.362 1.202 3.497-.134 4.75l-.168.168c-.424.403-.564 1.021-.377 1.515a17.38 17.38 0 0 0 8.772 8.751 1.445 1.445 0 0 0 1.609-.328l.252-.249a3.38 3.38 0 0 1 4.642.059l2.884 2.884a3.377 3.377 0 0 1-.146 4.762l-.83.803q.188.231.388.444a2.33 2.33 0 0 0 3.166.119l.128-.119 6.64-6.64a3.33 3.33 0 0 1 3.568-.745q-.184.465-.387.923a2.33 2.33 0 0 0-2.347.412l-.128.118-6.64 6.64a3.333 3.333 0 0 1-4.717-.011 10 10 0 0 1-.392-.443l-.277.267-1.338 1.336a3.44 3.44 0 0 1-3.842.569c-7.88-4-17.069-11.984-21.823-21.739a3.47 3.47 0 0 1 .712-3.943l1.247-1.237zm3.445 1.287a1.38 1.38 0 0 0-.999-.382 1.4 1.4 0 0 0-1.002.477L7.814 17.11 6.56 18.355a1.465 1.465 0 0 0-.311 1.657c4.527 9.29 13.398 16.996 20.905 20.807a1.44 1.44 0 0 0 1.669-.316l1.222-1.222 1.85-1.79c.555-.52.584-1.392.088-1.924l-2.844-2.844a1.38 1.38 0 0 0-1.972.064l-.254.248a3.45 3.45 0 0 1-3.68.609 19.42 19.42 0 0 1-9.817-9.817 3.44 3.44 0 0 1 .827-3.714l.172-.172c.555-.52.584-1.392.088-1.924z",
    clipRule: "evenodd"
  })));
};

export { IconContactByPhone, IconContactByPhone as default };
